// @angular
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerFeatureRoutingModule } from './ect-feature-routing.module';

// Components
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { CustomerFeatureComponent } from './ect-feature.component';
import { ConfigurationDetailComponent } from './configuration-detail/configuration-detail.component';
import { StackDetailComponent } from './stack-detail/stack-detail.component';
import { ConfigurationListComponent } from './configuration-list/configuration-list.component';
import { ParameterDetailComponent } from './parameter-detail/parameter-detail.component';
import { ParameterListComponent } from './parameter-list/parameter-list.component';

// Services
import { CustomerService } from './services/customer.service';
import { ConfigurationService } from './services/configuration.service';
import { ParameterService } from './services/parameter.service';
import { EctUserGuard } from './services/ect-user.guard';
import { EctAdminGuard } from './services/ect-admin.guard';

// Third Party
import { NgbModule, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { TreeviewModule } from '@laijuthomas/ngx-treeview';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AdministrationComponent } from './administration/administration.component';
import { AddParametersConfirmationWindowComponent } from './add-parameters-confirmation-window/add-parameters-confirmation-window.component';
import {Select2Module} from '../shared/Select2Module';
import {ConfigurationDeleteConfirmationDialogComponent} from "./configuration-delete-confirmation-dialog/configuration-delete-confirmation-dialog.component";
import {ParametersDeleteConfirmationDialogComponent} from "./parameters-delete-confirmation-dialog/parameters-delete-confirmation-dialog.component";
import {MymatrixConfirmationDialogComponent} from "./mymatrix-confirmation-dialog/mymatrix-confirmation-dialog.component";
import {StackService} from './services/stack.service';
import {ParameterValueValidatorDirective} from './validators/parameter-value-validator';
import { CustomerParametersComponent } from './customer-parameters/customer-parameters.component';
import { ColumnOrderDirective } from '../shared/directives/column-order.directive';
import { ColumnOrderDataDirective } from '../shared/directives/column-order-data-source.directive';
import { OktaConfigurationComponent } from './okta-configuration/okta-configuration.component';
import {SharedModule} from '../shared/shared.module';
import { ActivateDeactivateConfirmationDialogComponent } from './activate-deactivate-confirmation-dialog/activate-deactivate-confirmation-dialog.component';
import {InformationDialogComponent} from './information-dialog/information-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    TreeviewModule.forRoot(),
    NgxBootstrapMultiselectModule,
    CustomerFeatureRoutingModule,
    Select2Module,
    SharedModule
  ],
  declarations: [
    CustomerFeatureComponent,
    CustomerDetailComponent,
    CustomerListComponent,
    ConfigurationDetailComponent,
    StackDetailComponent,
    ConfigurationListComponent,
    ParameterListComponent,
    ParameterDetailComponent,
    AdministrationComponent,
    AddParametersConfirmationWindowComponent,
    ActivateDeactivateConfirmationDialogComponent,
    ConfigurationDeleteConfirmationDialogComponent,
    ParametersDeleteConfirmationDialogComponent,
    MymatrixConfirmationDialogComponent,
    InformationDialogComponent,
    ParameterValueValidatorDirective,
    CustomerParametersComponent,
    ColumnOrderDirective,
    ColumnOrderDataDirective,
    OktaConfigurationComponent
  ],
  providers: [
    NgbDropdown,
    CustomerService,
    ConfigurationService,
    ParameterService,
    StackService,
    EctUserGuard,
    EctAdminGuard,
    DatePipe,
    ParameterValueValidatorDirective,
    provideHttpClient(withInterceptorsFromDi())
  ],
})
export class CustomerFeatureModule { }
